import { ComponentFactoryResolver, ComponentRef, EmbeddedViewRef, Injectable, Injector } from '@angular/core';
import defaults from 'lodash-es/defaults';
import { NotificationAreaComponent } from './area/notification-area.component';
import { NNotification } from './notification.interfaces';
@Injectable({
    providedIn: 'root'
})
export class NotificationService {
    /**
     * Notification area component ref
     */
    private areaRef?: ComponentRef<NotificationAreaComponent>;
    constructor(private injector: Injector, private componentFactoryResolver: ComponentFactoryResolver) { }
    add(notification: NNotification.IData) {
        this.createArea();
        this.areaRef!.instance.add(defaults(notification, { duration: 5000 }));
    }
    toErrorMsg(err: Error | string | null | undefined | any): string {
        const error = err && typeof err === 'object' ? err.message || err.error : err;
        return typeof error === 'string' ? error : 'Unexpected error';
    }
    createArea() {
        if (!this.areaRef) {
            this.areaRef = this.componentFactoryResolver.resolveComponentFactory(NotificationAreaComponent).create(this.injector);
            const domElem = (this.areaRef.hostView as EmbeddedViewRef<any>).rootNodes[0] as HTMLElement;
            document.body.appendChild(domElem);
            this.areaRef.onDestroy(() => {
                this.areaRef = undefined;
            });
            this.areaRef.changeDetectorRef.detectChanges();
        }
    }
}
